import React from "react";
import { useNavigate } from "react-router-dom";

const ExamNotesPricing = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path); // Navigate to the given path
  };

  return (
    <div id="allnotes-inner-wrapper">
      {/* Adjust the import path according to your project structure */}
      <div className="allnotes-table-wrapper">
        <h5 className="mx-4">Choose a Category</h5>
        <div className="allnotes-cards-wrapper">
          {/* School Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/exam-notes-pricing/add-school-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>School Notes (Pricing)</b>
            </div>
          </div>

          {/* School Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/exam-notes-pricing/add-nios-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>Nios Notes (Pricing)</b>
            </div>
          </div>

          {/* College Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/exam-notes-pricing/add-university-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>University Notes (Pricing)</b>
            </div>
          </div>

          {/* Competitive Exam Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/exam-notes-pricing/add-competition-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>Competitive Exam (Pricing)</b>
            </div>
          </div>
          {/* Other Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/exam-notes-pricing/add-other-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>Other (Pricing)</b>
            </div>
          </div>
        </div>
        {/* <div className="form-btns items-right">
          <button className="btn-save">Next</button>
          <button className="btn-cancel">Cancel</button>
        </div> */}
      </div>
    </div>
  );
};

export default ExamNotesPricing;
